<template>
  <div id="line-official-line-official-account-choose">
    <div class="text-center _fs-24 _fs-sm-36">
      เลือก Basic ID
    </div>

    <div class="d-flex flex-column _pt-20 _pt-sm-30">
      <div class="text-center">
        กรุณาเลือก Basic ID ของท่าน
      </div>

      <v-row justify="center">
        <v-col sm="6">
          <v-radio-group
            v-if="hasLineOfficialAccount && lineOfficialAccounts.length"
            v-model="chosenBasicId">
            <template v-for="ownLineOfficialAccount in lineOfficialAccounts">
              <v-radio
                v-if="isLineOfficialAccountInactive(ownLineOfficialAccount)"
                :key="`disabled-${ownLineOfficialAccount._id}`"
                disabled>
                <span slot="label">
                  {{ ownLineOfficialAccount.lineOfficialAccount.basicId }}
                  <span class="error--text font-weight-bold">
                    (ไม่สามารถใช้งานได้)
                  </span>
                </span>
              </v-radio>
              <v-radio
                v-else
                :key="ownLineOfficialAccount._id"
                :label="ownLineOfficialAccount.lineOfficialAccount.basicId"
                :value="ownLineOfficialAccount.lineOfficialAccount._id">
                <span slot="label">
                  {{ ownLineOfficialAccount.lineOfficialAccount.basicId }}
                  <span
                    v-if="ownLineOfficialAccount.lineOfficialAccount.displayName"
                    class="primary--text">
                    ({{ ownLineOfficialAccount.lineOfficialAccount.displayName }})
                  </span>
                </span>
              </v-radio>
            </template>
          </v-radio-group>
          <div
            v-else
            class="text-center py-10 grey--text">
            ไม่พบ Basic ID ของท่านในระบบ
          </div>
        </v-col>
      </v-row>

      <div class="d-flex flex-column align-center">
        <v-btn
          style="padding: 0px 64px;"
          color="primary"
          rounded
          :disabled="!chosenBasicId"
          @click="submit">
          เข้าสู่บัญชี
        </v-btn>

        <v-btn
          class="mt-4"
          color="primary"
          rounded
          outlined
          :to="{ name: 'LineOfficialAccountCreate' }">
          <v-icon
            class="mr-1"
            size="medium">
            mdi-plus
          </v-icon>
          เพิ่มบัญชี LINE OA
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { isUpdatedProfile } from '@/utils/order.util'

export default {
  name: 'LineOfficialAccountChooseComponent',
  data () {
    return {
      chosenBasicId: ''
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      activeLineOfficialAccount: 'User/activeLineOfficialAccount',
      hasLineOfficialAccount: 'User/hasLineOfficialAccount',
      ownLineOfficialAccounts: 'User/ownLineOfficialAccounts'
    }),
    isProfileUpdate() {
      return !isUpdatedProfile(this.activeLineOfficialAccount)
    },
    lineOfficialAccounts() {
      return this.ownLineOfficialAccounts.filter((item) => !item.lineOfficialAccount.hide)
    }
  },
  methods: {
    ...mapActions({
      fetchProfile: 'User/fetchProfile',
      setSelectBasicId: 'User/setSelectBasicId',
      chooseLineAccount: 'Auth/chooseLineAccount'
    }),
    ...mapWaitingActions('Auth', {
      chooseLineAccount: 'app loading'
    }),
    ...mapWaitingActions('User', {
      fetchProfile: 'app loading'
    }),
    isLineOfficialAccountInactive (ownLineOfficialAccount) {
      return ownLineOfficialAccount.status === 'inactive' || ownLineOfficialAccount.lineOfficialAccount.status === 'inactive'
    },
    async submit () {
      const { userToken } = await this.chooseLineAccount({
        lineOfficialAccountId: this.chosenBasicId
      })
      this.$utils.setUserToken(userToken)
      this.setSelectBasicId(true)

      await this.fetchProfile()

      if (this.isProfileUpdate) {
        this.$router.push({ name: 'ProfileEdit' })
      } else {
        this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>
